import { useCallback } from 'react';

import { AButton } from 'components/atoms';

import { useCropImageContext } from '../useCropImageContext/useCropImageContext';
import {
  MODAL_CANCEL_BTN,
  MODAL_CLOSE_BTN,
  MODAL_OK_BTN,
  MODAL_SAVE_BTN,
} from '../utils/constants';

import styles from './ModalEditButtons.module.scss';

export const ModalEditButtons = () => {
  const {
    imageUrl,
    isLoadingImage,
    isErrorSaving,
    isWarningExit,
    isLoadingSaveImage,
    saveImg,
    secureExitModal,
    returnEditingView,
  } = useCropImageContext();

  const cancelBtnAction = useCallback(() => {
    if (isWarningExit) {
      return returnEditingView;
    }

    return secureExitModal;
  }, [isWarningExit, returnEditingView, secureExitModal]);

  return (
    <div className={styles.footer}>
      <AButton
        className={`button-secondary ${styles.footer__btn}`}
        handleClick={cancelBtnAction()}
        disabled={isLoadingSaveImage}
        tag='button'
      >
        {!isErrorSaving && MODAL_CANCEL_BTN}
        {isErrorSaving && MODAL_CLOSE_BTN}
      </AButton>
      {!isWarningExit && !isErrorSaving && (
        <AButton
          className={`button-primary ${styles.footer__btn}`}
          handleClick={saveImg}
          disabled={!imageUrl || isLoadingImage || isLoadingSaveImage}
          tag='button'
        >
          {MODAL_SAVE_BTN}
        </AButton>
      )}
      {isWarningExit && (
        <AButton
          className={`button-primary ${styles.footer__btn}`}
          tag='button'
          handleClick={secureExitModal}
        >
          {MODAL_OK_BTN}
        </AButton>
      )}
    </div>
  );
};
